import { entities } from "sbtech-sports-data-api-client";
import { MarketFilter } from "./Interfaces";

export class MarketFilterController {

    checkers: Array<MarketFilter> | undefined;
    defaultChecker: MarketFilter | undefined;

    constructor(checker: Array<MarketFilter> | undefined, defaultChecker: MarketFilter | undefined)
    {
        this.checkers = checker;
        this.defaultChecker = defaultChecker;
    }

    public isValid(market: entities.Market): boolean {
       if (this.checkers)
       {
            for (let index = 0; index < this.checkers.length; index++) {
                let checker = this.checkers[index];
                if (checker.isMatch(market)) {
                    return checker.isValid(market);
                }
            }
       }

       if (this.defaultChecker && this.defaultChecker.isMatch(market))
       {
            return this.defaultChecker.isValid(market);
       }

       return true;
    }
}